<template>
    <AnagraficaCrud titolo="Province" endpoint="province" nuovo-label="Nuova provincia" :colonne="colonne"
        :campi="campi" :puo-scrivere="true" colonne-import="Sigla, Provincia (nome)" />
</template>

<script>
import AnagraficaCrud from "@/components/AnagraficaCrud.vue";

export default {
    name: "ProvincePage",
    components: { AnagraficaCrud },

    data() {
        return {
            colonne: [
                { title: "Sigla", key: "sigla" },
                { title: "Provincia", key: "nome" },
            ],
            campi: [
                { key: "sigla", label: "Sigla", tipo: "text", required: true },
                { key: "nome", label: "Provincia", tipo: "text", required: true },
            ],
        };
    },
};
</script>
